import React, { useState, useContext } from 'react';
import {
  Dialog,
  Slide,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
  Button,
  Grid,
  Divider,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from '@mui/styles';
import MuiDialogContent from "@mui/material/DialogContent";
import UserCart from "./owner.room.cart";
import OutMenu from "../menu/owner.menu.outmenu";
import DishVariantsSelector from '../../user/reservation/DishVariantsSelector';
import { ReservationContext } from '../../../contexts/reservation.context';

const useStyles = makeStyles((theme) => ({
  categoryCard: { display: 'flex', flexWrap: 'wrap', marginBottom: theme.spacing(0.5) + ' !important', width: '100%', borderRadius: theme.spacing(1) + ' !important', color: '#fff !important', height: 'auto', padding: theme.spacing(0.1) },
  dishCard: { display: 'flex', flexWrap: 'wrap', marginBottom: theme.spacing(0.5), borderRadius: theme.spacing(1), color: '#fff', height: 'auto', padding: theme.spacing(0.1) },
  dialogContent: {
    padding: theme.spacing(2),
    //backgroundColor: '#121212', // Sfondo scuro profondo
    minHeight: '100vh',
  },
  sectionTitle: {
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    fontSize: '0.9rem !important',
    fontWeight: 700,
    marginBottom: theme.spacing(2) + ' !important',
  },
  categoryContainer: {
    marginBottom: theme.spacing(2),
  },

  categoryButton: {
    height: '100%', // Uniforma l'altezza se un nome va su due righe
    padding: '10px 5px !important',
    borderRadius: '12px !important',
    backgroundColor: '#1e1e1e !important',
    border: '1px solid #333 !important',
    color: '#eee !important',
    textTransform: 'none !important',
    fontSize: '0.85rem !important',
    textAlign: 'center',
    lineHeight: '1.2 !important',
    '&:hover': {
      backgroundColor: '#2a2a2a !important',
      borderColor: '#444 !important',
    },
  },

  categoryButtonSelection: {
    height: '100%',
    padding: '10px 5px !important',
    borderRadius: '12px !important',
    background: 'linear-gradient(45deg, #00c853 30%, #b2ff59 90%) !important',
    color: '#000 !important',
    fontWeight: 'bold !important',
    textTransform: 'none !important',
    fontSize: '0.85rem !important',
    boxShadow: '0 4px 12px rgba(0, 200, 83, 0.3)',
  },
  dishCardCustom: {
    height: '100%',
    minHeight: '100px',
    borderRadius: '16px !important',
    backgroundColor: '#1d1d1d !important',
    border: '1px solid #2d2d2d !important',
    color: '#fff !important',
    textTransform: 'none !important',
    fontSize: '1rem !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'transform 0.2s, background-color 0.2s !important',
    '&:hover': {
      backgroundColor: '#252525 !important',
      transform: 'translateY(-2px)',
      borderColor: '#444 !important',
    },
  },
  cartContainer: {
    backgroundColor: '#1d1d1d',
    padding: '20px',
    borderRadius: '20px',
    border: '1px solid #2d2d2d',
    position: 'sticky',
    top: '20px',
  },
  numberOrder: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    backgroundColor: '#ff3d00', // Rosso vibrante
    color: 'white',
    borderRadius: '8px',
    minWidth: '24px',
    height: '24px',
    fontSize: '12px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(255, 61, 0, 0.5)',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogMenu({ setOpenDialog, openDialog, handleClickOrder, tableId, dataMenuObj, ownerId, deliveryId, userId, form }) {
  const classes = useStyles();
  const [dish, setDish] = useState([]);
  const [categorySelected, setCategorySelected] = useState("");
  const [showOutMenu, setShowOutMenu] = useState(false);
  const [dialogDish, setDialogDish] = useState(null); // piatto selezionato per le varianti
  const [variantsSelection, setVariantsSelection] = useState([]);
  const [openVariantsDialog, setOpenVariantsDialog] = useState(false); // dialog varianti
  const [amountTotalCart, setAmountTotalCart] = useState({});
  const [deletedNotes, setDeletedNotes] = useState(""); // note dei NO {label}
  const [deletedOptionIds, setDeletedOptionIds] = useState([]);

  const { addToCart, cart, setCart } = useContext(ReservationContext);

  const safeVariants = Array.isArray(dialogDish?.variants) ? dialogDish.variants : [];

  const getNameDish = (categoryId, nameCategoria) => {
    setCategorySelected(nameCategoria);
    const filterDish = dataMenuObj.dataMenu
      .filter(el => el.categoryId === categoryId)
      .sort((a, b) => a.name.localeCompare(b.name));
    setDish(filterDish);
  };

  const handleClickNameDish = (dishItem) => {
    if (!dishItem.variants) dishItem.variants = [];
    dishItem.variants.forEach(v => {
      v.options.sort((a, b) => a.label.toLowerCase().trim().localeCompare(b.label.toLowerCase().trim()));
    });

    if (dishItem.variants.length) {
      dishItem.variants.sort((a, b) => a.position - b.position);
      setDialogDish(dishItem);
      setVariantsSelection([]);
      setDeletedNotes("");
      setOpenVariantsDialog(true);
    } else {
      addToCart({ ...dishItem, amount: 1, note: "" });
    }
  };

  const handleConfirmVariants = () => {
    if (!dialogDish) return;

    const variantsForCart = safeVariants
      .map(v => {
        const selected = variantsSelection.find(sel => sel.id === v.id)?.selected;

        // *************************************************************
        // 1. Filtra gli ID eliminati che appartengono a QUESTA variante (v)
        const currentVariantDeletedIds = deletedOptionIds.filter(id =>
          v.options.some(opt => opt.id === id)
        );
        // *************************************************************

        // LOGICA DI PULIZIA (che hai aggiunto):
        if (!selected || selected.length === 0) {
          // Se non ci sono selezioni positive E nemmeno eliminazioni, scarta (Null)
          if (currentVariantDeletedIds.length === 0) {
            return null;
          }
        }

        return {
          ...v,
          selected: selected || [],
          deletedOptions: currentVariantDeletedIds // <--- **SALVATAGGIO ID ELIMINATI**
        };
      })
      .filter(Boolean); // Rimuove i null

    const noteFinale = deletedNotes || "";

    addToCart({
      ...dialogDish,
      amount: 1,
      note: noteFinale,
      variants: variantsForCart,
    });

    // reset
    setOpenVariantsDialog(false);
    setDialogDish(null);
    setVariantsSelection([]);
    setDeletedNotes("");
    setDeletedOptionIds([]); // <--- **RESETTA ANCHE GLI ID**
  };

  const getAmountTotal = (totalCart) => {
    const amountMap = {};
    totalCart.forEach(d => { amountMap[d.id] = (amountMap[d.id] || 0) + d.amount; });
    setAmountTotalCart(amountMap);
  };

  return (
    <MuiDialogContent>
      <Dialog onClose={handleClickOrder} TransitionComponent={Transition} fullScreen open={openDialog}>
        <AppBar position="sticky">
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClickOrder} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6">{deliveryId ? form : tableId ? 'Tavolo ' + tableId : 'Nuova consegna / Ritiro'}</Typography>
          </Toolbar>
        </AppBar>

        <div className={classes.dialogContent}>
          {/* Header Categorie */}
          <Typography variant="body2" className={classes.sectionTitle}>
            Categorie
          </Typography>
          <Grid container spacing={1} className={classes.categoryContainer}>
            {dataMenuObj.categories.map((category, index) => {
              const isSelected = dish[0]?.categoryId === category.id;
              return (
                <Grid item xs={6} sm={4} md={2} key={index}>
                  <Button
                    fullWidth // Fa sì che il bottone occupi tutto lo spazio della colonna
                    className={isSelected ? classes.categoryButtonSelection : classes.categoryButton}
                    onClick={() => getNameDish(category.id, category.name)}
                  >
                    {category.name}
                  </Button>
                </Grid>
              );
            })}
          </Grid>

          <Divider sx={{ my: 3, borderColor: '#2d2d2d' }} />

          <Grid container spacing={3}>
            {/* Sezione Piatti */}
            <Grid item xs={12} md={8}>
              <Typography variant="h5" sx={{ fontWeight: 800, mb: 2, color: '#fff' }}>
                {categorySelected || "Seleziona una categoria"}
              </Typography>

              <Grid container spacing={2}>
                {dish.map((el, index) => (
                  <Grid item xs={6} sm={4} lg={3} key={index}>
                    <Button
                      className={classes.dishCardCustom}
                      fullWidth
                      onClick={() => handleClickNameDish(el)}
                    >
                      <Typography variant="body1" sx={{ fontWeight: 600, textAlign: 'center', px: 1 }}>
                        {el.name}
                      </Typography>

                      {/* Badge quantità */}
                      {amountTotalCart[el.id] > 0 && (
                        <span className={classes.numberOrder}>
                          {amountTotalCart[el.id]}
                        </span>
                      )}
                    </Button>
                  </Grid>
                ))}
              </Grid>
              {/* Padding per scroll mobile */}
              <Box sx={{ height: 100 }} />
            </Grid>

            {/* Sezione Carrello (Sticky) */}
            <Grid item xs={12} md={4}>
              <div className={classes.cartContainer}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }}>
                  Riepilogo Ordine
                </Typography>
                <UserCart
                  tableId={tableId}
                  ownerId={ownerId}
                  userId={userId}
                  deliveryId={deliveryId}
                  getAmountTotal={getAmountTotal}
                  handleClickOrder={handleClickOrder}
                  openDialog={openDialog}
                  setOpenDialog={setOpenDialog}
                />
              </div>
            </Grid>
          </Grid>
        </div>

        <OutMenu dishes={cart} setDishes={setCart} setShowOutMenu={setShowOutMenu} showOutMenu={showOutMenu} />

        {/* Dialog varianti */}
        {dialogDish && (
          <Dialog
            open={openVariantsDialog}
            fullScreen
            onClose={() => setOpenVariantsDialog(false)}
            TransitionComponent={Transition}
          >
            <AppBar position="sticky">
              <Toolbar>
                <Typography variant="h6" style={{ flexGrow: 1 }}>{dialogDish.name}</Typography>
                <IconButton edge="end" color="inherit" onClick={() => setOpenVariantsDialog(false)}>
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <MuiDialogContent
              style={{
                paddingBottom: 90, // spazio per il bottone
              }}
            >
              <DishVariantsSelector
                dish={{ ...dialogDish, variants: safeVariants }}
                variantsSelection={variantsSelection}
                setVariantsSelection={setVariantsSelection}
                mode="owner"
                onDeletedNotesChange={(notes, deletedIds) => {
                  setDeletedNotes(notes);
                  setDeletedOptionIds(deletedIds || []);
                }}
              />
            </MuiDialogContent>

            {/* FOOTER STICKY */}
            <Box
              sx={{
                position: 'sticky',
                bottom: 0,
                backgroundColor: '#000',
                px: 2,
                py: 1.5,
                boxShadow: '0 -4px 10px rgba(0,0,0,0.35)',
                zIndex: 1300,
              }}
            >
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleConfirmVariants}
                sx={{
                  fontSize: 18,
                  py: 1.5,
                  borderRadius: 2,
                }}
              >
                Aggiungi al carrello
              </Button>
            </Box>
          </Dialog>
        )}
      </Dialog>
    </MuiDialogContent>
  );
}

export default DialogMenu;
